import { RegistrationsList } from '../registrations-list';

export class Registration extends RegistrationsList {
    outingIterationId: string;
    lastEditedBy: string;
    stripePaymentIntentId: string;
    refundAmount: number;
    refundReason: string;
}
